import PropTypes from 'prop-types';

export default {
  ResyAmexConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string.isRequired,
    gdaEditorialApi: PropTypes.string.isRequired,
  }).isRequired,
  isNonUS: PropTypes.bool.isRequired,
  isLinkRedirectPnFixEnabled: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};
